import middleware from "../../../Api/Middleware";
import ToastPromise from "../../../Toasts/ToastPromise";

const Policies = ({ companyInfo }) => {
    const downloadFile = async (path, fileName) => {
        const downloadPromise = async () => {
            const res = await middleware.get(`settings/backOfficePolicyImages?path=${path}`, {
                responseType: 'blob'
            });

            // Creëer een blob URL en download het bestand
            const blob = new Blob([res.data]);
            const blobUrl = URL.createObjectURL(blob);
            
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);

            return fileName; // Return de filename voor de success message
        };

        await ToastPromise({
            promise: downloadPromise(),
            pending: `${fileName} wordt gedownload...`,
            successRenderer: (data) => `${data} succesvol gedownload!`,
            errorRenderer: (error) => `Er is iets fout gegaan tijdens het downloaden van het ${fileName} bestand. Probeer het later opnieuw.`,
            autoClose: 3000
        });
    };

    return (
        <div className="p-4 pb-0 w-50 parentCompanyInfoColumn">
            <div className="d-flex justify-content-between pb-4">
                <h6 className="w-50 fw-bold">Algemene voorwaarden</h6>
                <h6 className="w-50">
                    {companyInfo.general_condition ? (
                        <span
                            className="BlueText hover"
                            onClick={() => downloadFile(companyInfo.general_condition, "Algemene_Voorwaarden.pdf")}
                        >
                            Algemene_Voorwaarden.pdf
                        </span>
                    ) : (
                        "Niet beschikbaar"
                    )}
                </h6>
            </div>
            <div className="d-flex justify-content-between pb-4">
                <h6 className="w-50 fw-bold">Privacy statement</h6>
                <h6 className="w-50">
                    {companyInfo.privacy_statement ? (
                        <span
                            className="BlueText hover"
                            onClick={() => downloadFile(companyInfo.privacy_statement, "Privacy_Statement.pdf")}
                        >
                            Privacy_Statement.pdf
                        </span>
                    ) : (
                        "Niet beschikbaar"
                    )}
                </h6>
            </div>
            <div className="d-flex justify-content-between pb-4">
                <h6 className="w-50 fw-bold">Disclaimer</h6>
                <h6 className="w-50">
                    {companyInfo.disclaimer ? (
                        <span
                            className="BlueText hover"
                            onClick={() => downloadFile(companyInfo.disclaimer, "Disclaimer.pdf")}
                        >
                            Disclaimer.pdf
                        </span>
                    ) : (
                        "Niet beschikbaar"
                    )}
                </h6>
            </div>
        </div>
    );
};

export default Policies;
